export default "__VITE_ASSET__5e787b83__"